import React from "react";
import "./ComingSoon.css";
function ComingSoon() {
  return (
    <div className="container">
      <div className="text">
        <h1>Bismack Designs</h1>
        <h2>A new look is on its way...</h2>
      </div>
    </div>
  );
}
export default ComingSoon;
